import React, { FC } from 'react';

import { CreditCardOutlined } from '@ant-design/icons';

import MilePriceBadge from '@uikit/milePriceBadge';

import { TotalMileAmountWrapper } from './styled';

export interface ITotalMileAmount {
  totalMileAmount?: number;
}

const TotalMileAmount: FC<ITotalMileAmount> = ({ totalMileAmount = 0 }) => {
  return (
    <TotalMileAmountWrapper>
      <CreditCardOutlined />
      <MilePriceBadge milePrice={totalMileAmount} />
    </TotalMileAmountWrapper>
  );
};

export default TotalMileAmount;
